import { usePageTitle } from '$components'
import { Navigate } from 'react-router'

export function DashboardPage() {
  usePageTitle('Dashboard')

  return (
    <Navigate
      to="/calendar"
      replace
    />
  )

  return (
    <div>
      Dashboard
    </div>
  )
}
